import { createContext } from 'react';

var ColorModeContext = /*#__PURE__*/createContext({
  colorMode: void 0,
  toggleColorMode: void 0,
  setColorMode: void 0
});

export { ColorModeContext };
//# sourceMappingURL=context.esm.js.map
